
import { useEffect } from 'react'

// Composant pour charger le CSS critique en priorité
export const CriticalCSS = () => {
  useEffect(() => {
    // Précharger les polices critiques
    const preloadFont = (fontFamily: string, fontWeight: string = '400') => {
      const link = document.createElement('link')
      link.rel = 'preload'
      link.as = 'font'
      link.type = 'font/woff2'
      link.crossOrigin = 'anonymous'
      link.href = `https://fonts.googleapis.com/css2?family=${fontFamily}:wght@${fontWeight}&display=swap`
      document.head.appendChild(link)
    }

    preloadFont('Inter', '400,500,600,700')

    // Optimiser les images avec srcset
    const images = document.querySelectorAll('img')
    images.forEach(img => {
      if (!img.loading) {
        img.loading = 'lazy'
      }
    })
  }, [])

  return null
}
